import React, { useRef, useEffect, useState } from 'react';
import { connect } from "react-redux";
import { compose } from "redux";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from 'recharts';

const dummyData = [
  { action_status: 'Due to 30', count: 40 },
  { action_status: 'Overdue 0-30', count: 30 },
  { action_status: 'Overdue 30-60', count: 20 },
  { action_status: 'Overdue 60', count: 10 },
];

const CATEGORY_COLORS = {
  software: '#05769D',
  hardware: '#F07167',
  services: '#00AFB9',
  virtual_machine: '#FED9B7',
  information_assets: '#b4170b',
  network_assets: '#4F46E5',
  organizational_people_assets: '#0081A7',
  facilities: '#6B7280',
  documentation_assets: '#10B981',
  iot: '#F59E0B',
};

const CATEGORY_LABELS = {
  software: 'Software',
  hardware: 'Hardware',
  services: 'Services',
  virtual_machine: 'Virtual Machine',
  information_assets: 'Info Assets',
  network_assets: 'Network',
  organizational_people_assets: 'People',
  facilities: 'Facilities',
  documentation_assets: 'Docs',
  iot: 'IoT',
};

const formattedDataFromAssets = (assets) => {
  const counts = {};
  assets.forEach((a) => {
    const cat = a.category || 'unknown';
    counts[cat] = (counts[cat] || 0) + 1;
  });
  const total = assets.length;
  return Object.entries(counts).map(([cat, count]) => ({
    name: CATEGORY_LABELS[cat] || cat,
    value: count,
    percentage: ((count / total) * 100).toFixed(1),
    color: CATEGORY_COLORS[cat] || '#8884d8',
  }));
};

const AssetMetric = ({ height = 250, assets }) => {

  const [processedData, setprocessedData] = useState([]);
  const totalActions = Array.isArray(assets) ? assets.length : 0;

  const outerRadius = height / 2.5;
  const innerRadius = outerRadius - 30;

  useEffect(() => {
    if (Array.isArray(assets) && assets.length > 0) {
      setprocessedData(formattedDataFromAssets(assets));
    }
  }, [assets]);

  return (
    <div className="w-full relative">
      <div className="absolute top-0 left-0 text-sm font-normal text-gray-800 z-20 ml-2 mt-2">
        {totalActions} Assets
      </div>
      <ResponsiveContainer width="100%" height={height}>
        <PieChart>
          <Pie
            data={processedData}
            cx="50%"
            cy="50%"
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            fill="#8884d8"
            dataKey="value"
            paddingAngle={2}
          >
            {processedData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
            <LabelList dataKey="name" position="outside" fontSize={10} />
          </Pie>
          <Tooltip formatter={(value, name, props) => [`${value}`, name]} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};


const mapStateToProps = (state) => {
    return {
        assets: state.asset.assets,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(AssetMetric);
